import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, LinkOptions } from '@tanstack/react-router'
import { FC } from 'react'
import { StoreApi, UseBoundStore } from 'zustand'

import { RootErrorComponent, RootRouteComponent } from '@/containers/root'
import { AccountManagementStore } from '@/store/accountManagement/types'
import { OrganizationStore } from '@/store/organization/types'

export type SubNavLink = LinkOptions & { label: string }
export type RouteContext = {
  queryClient: QueryClient
  orgStore: UseBoundStore<StoreApi<OrganizationStore>>
  accountManagementStore: UseBoundStore<StoreApi<AccountManagementStore>>
  HeaderComponent?: FC
  SidebarComponent?: FC
  title?: string
  subTitle?: string
  breadCrumbTitle?: string
  subNavLinks?: SubNavLink[]
}

export const Route = createRootRouteWithContext<RouteContext>()({
  component: RootRouteComponent,
  errorComponent: RootErrorComponent,
})
